import React from 'react';

export const NATURES_PROJET = ['Nouveau corner', 'Remodeling', 'Relifting', 'Matériel supplémentaire'];

export const getClientType = (nature) => {
  if (!nature) return 'non_renseigne';
  return nature === 'Nouveau corner' ? 'prospect' : 'client';
};

export const CLIENT_TYPE_CONFIG = {
  client: { label: 'Client', dot: 'bg-blue-500', text: 'text-blue-700', cls: 'bg-blue-50 border-blue-200', ring: 'ring-blue-400' },
  prospect: { label: 'Prospect', dot: 'bg-orange-500', text: 'text-orange-700', cls: 'bg-orange-50 border-orange-200', ring: 'ring-orange-400' },
  non_renseigne: { label: 'Non renseigné', dot: 'bg-slate-400', text: 'text-slate-500', cls: 'bg-slate-50 border-slate-200', ring: 'ring-slate-400' },
};

export const ClientTypeBadge = ({ nature, testId }) => {
  const c = CLIENT_TYPE_CONFIG[getClientType(nature)];
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[10px] sm:text-xs font-semibold shrink-0 ${c.cls} ${c.text}`}
      title={nature ? `Nature du projet : ${nature}` : 'Nature du projet non renseignée'} data-testid={testId}>
      <span className={`w-2 h-2 rounded-full ${c.dot}`} />{c.label}
    </span>
  );
};

export const ClientTypeCounters = ({ dossiers, value, onChange }) => {
  const counts = { client: 0, prospect: 0, non_renseigne: 0 };
  dossiers.forEach(d => { counts[getClientType(d.nature_projet)] += 1; });
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="client-type-counters">
      {Object.entries(CLIENT_TYPE_CONFIG).map(([k, c]) => {
        const active = value === k;
        return (
          <button key={k} type="button" onClick={() => onChange(active ? '' : k)}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-full border text-sm transition-[background-color,box-shadow] hover:shadow-sm ${c.cls} ${active ? `ring-2 ${c.ring}` : ''}`}
            data-testid={`counter-${k}`}>
            <span className={`w-2.5 h-2.5 rounded-full ${c.dot}`} />
            <span className={`font-semibold ${c.text}`}>{c.label}</span>
            <span className={`font-bold ${c.text}`} data-testid={`counter-${k}-value`}>{counts[k]}</span>
          </button>
        );
      })}
      {value && (
        <button type="button" onClick={() => onChange('')} className="text-xs text-slate-500 underline" data-testid="counter-reset">
          Tout afficher
        </button>
      )}
    </div>
  );
};
